module.exports = __webpack_public_path__ + "img/empty.3cbe84ed.png";